module.exports = __webpack_public_path__ + "img/variables_empty.cc2e9ad8.svg";